// extracted by mini-css-extract-plugin
export default {"payOutAbout":"PayOutAbout_payOutAbout__gvt-Y","payOutAboutTitle":"PayOutAbout_payOutAboutTitle__T1d4s"};